import { useContext, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AreaChart from "../../../components/fleet/JourneyInsightComponent/AreaChart";
import MapWithRoute from "../../../components/fleet/JourneyInsightComponent/MapWithRoute";
import VerticalStackedChart from "../../../components/fleet/JourneyInsightComponent/VerticalStackedChart";
import UserContext from "../../../Context/UserProvider";
import { Box, CircularProgress } from '@mui/material';
import { useApiService } from "../../../services/ApiService/ApiService";

function BuildQuoteJourneyInsightPage(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  const {userInfo, setUserInfo} = useContext(UserContext);
  const params = location.state as any;
  const [selectedJourney, setSelectedJourney] = useState() as any;
  const [selectedDistance, setSelectedDistance] = useState() as any;
  const [loading, setLoading] = useState(true);
  const [dailyBatteryUsage, setDailyBatteryUsage] = useState() as any;
  const [batteryUsageMap, setBatteryUsageMap] = useState() as any;
  const [mapPoints, setMapPoints] = useState() as any;
  const { fetchWithAuth } = useApiService();
  
  async function fetchInsight() {
    setLoading(true);
    try {
      const response = await fetchWithAuth('/journey/insight/get', {
        method: 'POST',
        body: JSON.stringify({
          uuid: userInfo.uuid,
          fleetUuid: userInfo.fleetUuid,
          comparisonUuid: location.state.comparisonUuid
        })
      });

      if (!response.ok) {
        throw new Error('Failed to fetch journey insight');
      }

      const res_json = await response.json();
      setDailyBatteryUsage(
        res_json.dailyBatteryUsageList.map((prev: any) => ({
          ...prev,
          startingBatteryLevel: +"1",
        }))
      );
      setBatteryUsageMap(res_json.batteryUsageMap);
      setMapPoints(res_json.mapPointsMap);
      setSelectedJourney(res_json.dailyBatteryUsageList[0].date);
      setSelectedDistance(res_json.dailyBatteryUsageList[0].distance);
    } catch (error) {
      console.error('Error fetching journey insight:', error);
    } finally {
      setLoading(false);
    }
  }

  useLayoutEffect(() => {
    fetchInsight();
  }, []);

  return (
    <>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      ) : (
        <div className="d-flex flex-column gap-3">
           <VerticalStackedChart
            data={dailyBatteryUsage}
            selectedJourney={[selectedJourney, setSelectedJourney]}
            selectedDistance={[selectedDistance, setSelectedDistance]}

          />
          {/* <h1>Daily Battery Usage for Journey</h1> */}
          <div className="d-flex flex-column flex-lg-row gap-3">
            <AreaChart
              data={batteryUsageMap}
              selectedJourney={selectedJourney}
            />
            {/* <h1>Journey Details</h1> */}
            <MapWithRoute
              data={mapPoints}
              selectedJourney={selectedJourney}
              selectedDistance={selectedDistance}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default BuildQuoteJourneyInsightPage;
